import { render, staticRenderFns } from "./DuplicateEmailError.vue?vue&type=template&id=027af63e&scoped=true&"
import script from "./DuplicateEmailError.vue?vue&type=script&lang=js&"
export * from "./DuplicateEmailError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027af63e",
  null
  
)

export default component.exports